/* eslint-disable @next/next/no-img-element */
import { getBannerLink } from "@/utils/topsortUtil";
import { useMemo } from "react";
import styles from "./headerBanner.module.scss";

export default function HeaderBanner({ topsortWinner, topsortBannerType }: HeaderBannerProps) {
  const isValidWinner = useMemo(() => {
    if (topsortWinner && topsortWinner.asset && topsortWinner.asset.length > 0) {
      return true;
    }
    return false;
  }, [topsortWinner]);

  const topsortImage = useMemo(() => {
    if (isValidWinner) {
      if (topsortBannerType === "desktop") {
        return {
          m: topsortWinner?.asset[0].url,
          l: topsortWinner?.asset[0].url,
          xl: topsortWinner?.asset[0].url,
          xxl: topsortWinner?.asset[0].url,
        };
      }
      if (topsortBannerType === "mobile") {
        return {
          s: topsortWinner?.asset[0].url,
        };
      }
    }
    return undefined;
  }, [topsortWinner, topsortBannerType]);

  const topsortLink = useMemo(() => {
    if (isValidWinner) {
      return getBannerLink(topsortWinner);
    }
    return undefined;
  }, [isValidWinner, topsortWinner]);

  const topsortId = useMemo(() => {
    if (isValidWinner && topsortWinner?.type === "product") {
      return topsortWinner.id;
    }
    return undefined;
  }, [isValidWinner, topsortWinner]);

  const imageSet = useMemo(() => {
    const { s, m, l, xl, xxl } = topsortImage || {};
    const template: SearchBannerImageObject & { largestImageAvailable?: string } = {
      s,
      m,
      l,
      xl,
      xxl,
      largestImageAvailable: undefined,
    };
    if (xxl) template.largestImageAvailable = xxl;
    else if (xl) template.largestImageAvailable = xl;
    else if (l) template.largestImageAvailable = l;
    else if (m) template.largestImageAvailable = m;
    else if (s) template.largestImageAvailable = s;
    return template;
  }, [topsortImage?.s, topsortImage?.m, topsortImage?.l, topsortImage?.xl, topsortImage?.xxl]);

  if (!isValidWinner) return null;

  return (
    <div className={styles["header-banner-container"]}>
      <a href={topsortLink} className={styles["banner-link"]}>
        <picture
          className={styles["banner-image"]}
          data-ts-product={topsortId}
          data-ts-resolved-bid={topsortWinner?.resolvedBidId}
          data-ts-clickable={true}
        >
          {imageSet.s && <source srcSet={imageSet.s} media="(max-width: 575.98px)" />}
          {imageSet.m && <source srcSet={imageSet.m} media="(max-width: 767.98px)" />}
          {imageSet.l && <source srcSet={imageSet.l} media="(max-width: 991.98px)" />}
          {imageSet.xl && <source srcSet={imageSet.xl} media="(max-width: 1199.98px)" />}
          {imageSet.xxl && <source srcSet={imageSet.xxl} media="(max-width: 1399.98px)" />}
          <img alt="" srcSet={imageSet.largestImageAvailable} />
        </picture>
      </a>
    </div>
  );
}

export type HeaderBannerProps = {
  topsortWinner: Winner | undefined | null;
  topsortBannerType: "desktop" | "mobile";
};
